var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "亲推奖", name: "1" } },
            [_c("bonus0", { attrs: { "bonus-data": _vm.bonusList[0] } })],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "极差奖", name: "2" } },
            [
              _c("bonus1", {
                attrs: {
                  "bonus-data": _vm.bonusList[1],
                  "grade-list": _vm.gradeList
                }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "管理奖", name: "3" } },
            [
              _c("bonus2", {
                attrs: {
                  "bonus-data": _vm.bonusList[2],
                  "level-list": _vm.levelList
                }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "福袋奖", name: "4" } },
            [_c("bonus10", { attrs: { "bonus-data": _vm.bonusList[7] } })],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "店补奖", name: "5" } },
            [_c("bonus11", { attrs: { "bonus-data": _vm.bonusList[8] } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }